// *******************************************************************************
// 1.0 - Filter Item
// *******************************************************************************

attachEvent('.filter-item__title', 'click', (ev) => {
  const parentElem = ev.target.closest('.filter-item');
  const contentEle = parentElem.querySelector('.filter-item__body')
  parentElem.classList.toggle('is-open');
  slideToggle(contentEle, 300, 'block');
});
